var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "widM marTX marBX" }, [
      _c("picture", [
        _c("source", {
          attrs: {
            media: "(max-width:639px)",
            srcset: require("@/assets/images/relay-event/cont_01_m.jpg")
          }
        }),
        _vm._v(" "),
        _c("source", {
          attrs: {
            media: "(min-width:640px)",
            srcset: require("@/assets/images/relay-event/cont_01.jpg")
          }
        }),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@/assets/images/relay-event/cont_01.jpg"),
            alt: "소비자 번호 확인하는 방법"
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "hide" }, [
        _c("p", [
          _vm._v(
            "소비자 번호 잊어버리신 분들을 위해서 본인의 소비자 번호를 확인하는 방법을 알려드립니다."
          )
        ]),
        _vm._v(" "),
        _c("h1", [_vm._v("소비자 번호 확인하는 방법")]),
        _vm._v(" "),
        _c("ol", [
          _c("li", [
            _vm._v("1단계 amway.co.kr에 접속하여 로그인 버튼 클릭(모바일 기준)")
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("2단계 카카오로 로그인 버튼 클릭")]),
          _vm._v(" "),
          _c("li", [_vm._v("3단계 우측 상단에 사람 모양 아이콘 클릭")]),
          _vm._v(" "),
          _c("li", [
            _vm._v("4단계 이름/회원번호/회원유형"),
            _c("a", { attrs: { href: "#comment01" } }, [_vm._v("*")]),
            _vm._v(" 확인 가능")
          ])
        ]),
        _vm._v(" "),
        _c("p", { attrs: { id: "comment01" } }, [
          _vm._v(
            "회원 유형은 이름 하단에 있으며 ABO는 Pin Level이, Member로, 소비자는 Customer로 표기됩니다."
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bb236e0e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb236e0e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/nutrilite/relayevent/component/footer_consumer.vue
// module id = null
// module chunks = 